
import styled from "styled-components";

export const MenuContainer = styled.div<{open: boolean, positionY: 'top' | 'bottom', positionX: 'left' | 'right'}>`
  position: absolute;
  display: ${props => props.open ? 'flex' : 'none'};
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: ${props => props.theme.colors.white};
  box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.10);
  border-radius: 8px;
  z-index: 999;

  opacity: ${props => props.open ? 1 : 0};

  transition: all 0.5s;

  ${props => props.positionY === 'top' ? "bottom: 115%" : "top: 115%"};
  ${props => props.positionX === 'left' ? "right: 15%" : "left: 15%"};
`;

export const Wrapper = styled.div`
  position: relative;

`

export const Item = styled.button`
  border: none;
  display: flex;
  background: transparent;
  align-items: center;
  justify-content: start;
  gap: 8px;
  cursor: pointer;
  padding: 8px 16px;

  &:hover {
    background: ${props => props.theme.colors.inputBackground};
  }
`;

export const MenuButton = styled.button<{onlyIcon: boolean}>`
  display: flex;
  width: 38px;  
  height: 38px; 
  justify-content: center;
  align-items: center;
  border-radius: 24px;
  background: ${props => props.onlyIcon ? 'transparent' : props.theme.colors.inputBackground} !important;
  cursor: pointer;
  border: none;

  transition: all 0.5s;

  &:active {
    background: ${props => props.theme.colors.line};
  }

  ${props => props.theme.mediaQuerie.maxWidth.sm}{
    background: ${props => props.theme.colors.line};
  }
`;